import { Component } from '@angular/core';
import { MenuController, Platform, AlertController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { CommonService } from '@common/services/common.service';
import { HeaderService } from '@common/services/header.service';
import { PlatformDetails} from '@common/models/platform-details'
import { Storage } from '@ionic/storage-angular';
import { Device } from '@ionic-native/device/ngx';
import { FetchEncryptionKeyService } from '@service/fetch-keys.service';
import { EncryptionProviderService } from '@common/services/encryption.service';
import { CORE_PROPS } from 'src/core/core.properties';
import { CoreService } from 'src/core/core.service';
import { AuthService } from "@common/services/auth.service";
import { Router } from '@angular/router';
import { Location } from '@angular/common'
import { AppVersion} from '@ionic-native/app-version/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';

declare let IRoot: any;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  isInvestorLoggedIn: boolean = false;
  isTransactMenuActive: boolean = false;
  platformDetails: PlatformDetails;
  platformDetailsCore:PlatformDetails;

  public keyLoaded:boolean = false;

  desktop: Boolean;
  isSwipeEnabled: boolean = false;
  isForceUpdateRequired:string;
  forceUpdateVersion:string;
  forceUpdateUrl:string;
  currentAppVersionNumber:string;
  deviceDetails: {
    cordovaVersion: string; deviceModel: string;
    // Here you can do any higher level native things you might need.
    osName: string; uuid: string; osVersion: string; deviceManufacturer: string; deviceSerialId: string;
  };
  
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private iab:InAppBrowser,
    private commonService: CommonService,
    private storage: Storage,
    private fetchEncryptionKeyService:FetchEncryptionKeyService,
    private menuCtrl: MenuController,
    private coreSrv: CoreService,
    private core_props: CORE_PROPS,
    private router:Router,
    private location:Location,
    private alertController:AlertController,
    private device:Device,
    private appVersion:AppVersion,
    private headerService:HeaderService
  ) {
    this.initFetchKey();
    this.initializeApp();
    this.storage.create();
  }

  initializeApp() {
  
    this.platform.ready().then(() => {
      if(navigator.onLine) {
        console.log("You are Online");
       }
       else {
        console.log("You are Offline");
       }

      
      this.menuCtrl.enable(false);

      this.statusBar.styleDefault();
      
      this.statusBar.backgroundColorByHexString('#ffffff');

      this.commonService.initailizePlatformDetails();

      this.platformDetails = this.commonService.getPlatformDetails();
      console.log(this.platformDetails);

      this.coreSrv.initailizeCorePlatformDetails();
      this.platformDetailsCore = this.coreSrv.getCorePlatformDetails();
      this.core_props.setCorePlatformDetails(this.platformDetailsCore);
      if (this.platformDetailsCore.isDesktop) {
        this.desktop = true;
        this.isSwipeEnabled = false
      } else {

        this.desktop = false;
        this.isSwipeEnabled = true;
        if (this.platformDetailsCore.isMobileApp) {
          this.deviceDetails = this.coreSrv.initailizeDeviceDetails();
          this.core_props.setDeviceDetails(this.deviceDetails);
        }
      }
      if (!this.desktop) {
        this.checkRootedMethod();
        this.appVersion.getVersionNumber().then(res => {
          console.log(res);
          this.currentAppVersionNumber = res.toString();
        });
        setTimeout(() => {    
          if (this.platform.is('cordova')) {
            this.forceUpdateFunctions();
          }
        })
      }
      document.addEventListener(
        'backbutton',
        (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (this.router.url === '/login') {
            navigator['app'].exitApp();
          }if (this.router.url === '/login/login-with-mpin' || this.router.url === '/login/with-otp') {
            this.location.back();
          }if (this.router.url === '/investor-dashboard') {
            this.confirmAlert("Are you sure you want to logout?" , "", "LOGOUT");
          }
          else {
            return;
          }
        },
        false
      );
    });

  }

  ngOnInit() {
    this.platform.ready().then(() => {
      this.checkRootedMethod();
    });
  }

  checkRootedMethod() {
    let successCallback = (data) => {
      if (data) {
        if (data == 'Emulator') {
          console.log("App cannot be used in an Emulator.");
          this.showAlert("App cannot be used in an Emulator.", "", "ROOT_CHECK");
        }
        else {
          console.log("Your device is rooted. You will not be able to continue.");
          this.showAlert("Your device is rooted. You will not be able to continue.", "", "ROOT_CHECK");
        }
      }
    };
    let failureCallback = (data) => {
      if (data == 'Not Rooted') {
        console.log("Device not rooted. You can continue.");
      }
    };
    if (this.platform.is("android") || this.platform.is('ios') || this.platform.is('ipad')) {
      if (this.device.isVirtual) {
        successCallback("Emulator");
      }
      else {
        IRoot.isRooted(successCallback, failureCallback('Not Rooted'));
      }
    }
  }

  async showAlert(subheader, message , popupType){
    const alert = await this.alertController.create({
      subHeader: subheader,
      backdropDismiss: false,
      message : message,
      buttons: [
        {
          text: 'OK',
          cssClass: 'alert-backButton',
          handler: () => {
            if (popupType === "ROOT_CHECK") {
              navigator['app'].exitApp();
            } else if (popupType === "FORCE_UPDATE") {
              this.iab.create(this.forceUpdateUrl, '_blank');
            }
          },
        },
      ],
    });
    await alert.present();
  }
  async confirmAlert(subheader,message,requestType) {
    let rightBtnText :string = "Yes";
    if(requestType === "SOFT_UPDATE"){
      rightBtnText = "Update Now";
    }
    const alert = await this.alertController.create({
      subHeader: subheader,
      backdropDismiss: false,
      message: message,
      buttons: [
        {
          text: 'Cancel',
          cssClass: 'alert-backButton',
          handler: () => {
            return;
          },

        },
        {
          text: rightBtnText,
          cssClass: 'alert-backButton',
          handler: () => {
            if (requestType === 'LOGOUT') {
              AuthService.logout();
              this.router.navigate(['/login']);
            } else if (requestType === 'SOFT_UPDATE') {
              this.iab.create(this.forceUpdateUrl, '_blank');
            }
          },
        },
      ],
    });
    await alert.present();
  }

  menuClose() {
    this.menuCtrl.close();
  }

  forceUpdateFunctions() {
    if (this.platform.is("android") || this.platform.is('ios') || this.platform.is('ipad')) {
      this.headerService.getForceUpdateInfo().subscribe(
        response => {
          if (response.status === 0) {
            if (this.platformDetails.isAndroidApp) {
              this.forceUpdateVersion = response.data.forceUpdateVersionAndroid;
              this.forceUpdateUrl = response.data.forceUpdateUrlAndroid;
              this.isForceUpdateRequired = response.data.isForceUpdateRequiredAndroid;
            } else {
              this.forceUpdateVersion = response.data.forceUpdateVersionIos;
              this.forceUpdateUrl = response.data.forceUpdateUrlIos;
              this.isForceUpdateRequired = response.data.isForceUpdateRequiredIos;
            }
            if (this.currentAppVersionNumber !== this.forceUpdateVersion) {
              if (this.isForceUpdateRequired === 'true') {
                this.showAlert("New version available", "To use this app, download the latest version", "FORCE_UPDATE");
              } else {
                this.confirmAlert("New version available", "Your application update is available", "SOFT_UPDATE");
              }
            }
          }
        },
        error => {
          console.log(error)
        }
      )
    }
  }

  public initFetchKey(){
    this.keyLoaded = false;
    this.fetchEncryptionKeyService.fetchPublicKey().subscribe(
      response=>{
        const data = response.data;
        if(data){
            EncryptionProviderService.isEncription = data.enableEnc;
            EncryptionProviderService.encryptionKey ='aar6tzij8o1snaar'; //data.key
        }
        this.keyLoaded = true;
      },error=>{
        this.keyLoaded = true;
      }
   )
  }

}
